<template>
  <div>
    <NavBar />
    <Edit
      :item="currentRevista"
      :numerosCadastrados="numerosCadastrados"
      :editorFunction="editorFunction"
      :mode="editorMode"
      :close="closeEditor"
      :onSuccess="onEditSuccess"
    />
    <div class="container">
      <SideBar />
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <div class="message" v-if="error">Erro: {{ error.message }}</div>
          <h1 class="title">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 296.999 296.999"
              style="enable-background: new 0 0 296.999 296.999"
              xml:space="preserve"
            >
              <g>
                <g>
                  <g>
                    <path
                      d="M45.432,35.049c-0.008,0-0.017,0-0.025,0c-2.809,0-5.451,1.095-7.446,3.085c-2.017,2.012-3.128,4.691-3.128,7.543 v159.365c0,5.844,4.773,10.61,10.641,10.625c24.738,0.059,66.184,5.215,94.776,35.136V84.023c0-1.981-0.506-3.842-1.461-5.382 C115.322,40.849,70.226,35.107,45.432,35.049z"
                    />
                    <path
                      d="M262.167,205.042V45.676c0-2.852-1.111-5.531-3.128-7.543c-1.995-1.99-4.639-3.085-7.445-3.085c-0.009,0-0.018,0-0.026,0 c-24.793,0.059-69.889,5.801-93.357,43.593c-0.955,1.54-1.46,3.401-1.46,5.382v166.779 c28.592-29.921,70.038-35.077,94.776-35.136C257.394,215.651,262.167,210.885,262.167,205.042z"
                    />
                    <path
                      d="M286.373,71.801h-7.706v133.241c0,14.921-12.157,27.088-27.101,27.125c-20.983,0.05-55.581,4.153-80.084,27.344 c42.378-10.376,87.052-3.631,112.512,2.171c3.179,0.724,6.464-0.024,9.011-2.054c2.538-2.025,3.994-5.052,3.994-8.301V82.427 C297,76.568,292.232,71.801,286.373,71.801z"
                    />
                    <path
                      d="M18.332,205.042V71.801h-7.706C4.768,71.801,0,76.568,0,82.427v168.897c0,3.25,1.456,6.276,3.994,8.301 c2.545,2.029,5.827,2.78,9.011,2.054c25.46-5.803,70.135-12.547,112.511-2.171c-24.502-23.19-59.1-27.292-80.083-27.342 C30.49,232.13,18.332,219.963,18.332,205.042z"
                    />
                  </g>
                </g>
              </g>
            </svg>
            Revistas
          </h1>

          <ul class="tabs"></ul>
          <div class="card">
            <div class="card-body">
              <table class="table">
                <thead>
                  <tr>
                    <th>Imagem de Capa</th>
                    <th>Descrição</th>
                    <th>Link</th>
                    <th>Ordem</th>
                    <th>Data Publicação</th>
                    <th>
                      <button
                        class="button button-success button-sm button-block"
                        v-on:click="openEditor()"
                      >
                        <svg
                          style="width: 12px; height: 12px; fill: #fff"
                          x="0px"
                          y="0px"
                          viewBox="0 0 42 42"
                        >
                          <path
                            d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"
                          />
                        </svg>
                        Adicionar
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-bind:class="{
                      'bg-error': !i.visivel || (i.visivel && !i.img),
                    }"
                    v-for="(i, index) in revistas"
                    v-bind:key="index"
                  >
                    <td>
                      <div class="imgbox" v-if="i.img !== ''">
                        <span>
                          <button
                            class="button button-error button-sm"
                            v-on:click="deleteImg(index)"
                          >
                            <svg
                              style="
                                margin-top: 4px;
                                width: 12px;
                                height: 12px;
                                fill: #fff;
                              "
                              x="0px"
                              y="0px"
                              viewBox="0 0 459 459"
                            >
                              <g>
                                <path
                                  d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"
                                />
                              </g>
                            </svg>
                          </button>
                          <img :src="getImage(i.img)" />
                        </span>
                      </div>
                      <div
                        class="imgbox"
                        v-bind:class="{ error: i.visivel && !i.img }"
                        v-else
                      >
                        <span>
                          <label class="button button-sm button-success">
                            <svg
                              style="
                                float: left;
                                width: 18px;
                                height: 18px;
                                fill: #fff;
                              "
                              x="0px"
                              y="0px"
                              viewBox="0 0 612 612"
                            >
                              <g>
                                <path
                                  d="M494.7,255C476.85,168.3,400.35,102,306,102c-73.95,0-137.7,40.8-168.3,102C58.65,214.2,0,277.95,0,357 c0,84.15,68.85,153,153,153h331.5c71.4,0,127.5-56.1,127.5-127.5C612,316.2,558.45,260.1,494.7,255z M357,331.5v102H255v-102 h-76.5L306,204l127.5,127.5H357z"
                                />
                              </g>
                            </svg>
                            <input
                              type="file"
                              name="img"
                              style="display: none"
                              accept="image/jpg, image/jpeg, image/png, image/webp"
                              @change="uploadImage(index)"
                            />
                          </label>
                        </span>
                      </div>
                    </td>
                    <td>{{ i.descricao }}</td>
                    <td>{{ i.link }}</td>
                    <td>
                      <span class="label primary">{{ i.ordem }}</span>
                    </td>
                    <td>
                      <span class="label success">{{
                        new Date(i.dataPubli).toLocaleDateString("pt-br")
                      }}</span>
                    </td>

                    <td class="actions">
                      <a
                        class="button button-primary"
                        v-on:click="openEditor(index)"
                      >
                        <svg
                          x="0px"
                          y="0px"
                          style="
                            margin-top: 4px;
                            width: 12px;
                            height: 12px;
                            fill: #fff;
                          "
                          viewBox="0 0 485.219 485.22"
                        >
                          <g>
                            <path
                              d="M467.476,146.438l-21.445,21.455L317.35,39.23l21.445-21.457c23.689-23.692,62.104-23.692,85.795,0l42.886,42.897 C491.133,84.349,491.133,122.748,467.476,146.438z M167.233,403.748c-5.922,5.922-5.922,15.513,0,21.436 c5.925,5.955,15.521,5.955,21.443,0L424.59,189.335l-21.469-21.457L167.233,403.748z M60,296.54c-5.925,5.927-5.925,15.514,0,21.44 c5.922,5.923,15.518,5.923,21.443,0L317.35,82.113L295.914,60.67L60,296.54z M338.767,103.54L102.881,339.421 c-11.845,11.822-11.815,31.041,0,42.886c11.85,11.846,31.038,11.901,42.914-0.032l235.886-235.837L338.767,103.54z M145.734,446.572c-7.253-7.262-10.749-16.465-12.05-25.948c-3.083,0.476-6.188,0.919-9.36,0.919 c-16.202,0-31.419-6.333-42.881-17.795c-11.462-11.491-17.77-26.687-17.77-42.887c0-2.954,0.443-5.833,0.859-8.703 c-9.803-1.335-18.864-5.629-25.972-12.737c-0.682-0.677-0.917-1.596-1.538-2.338L0,485.216l147.748-36.986 C147.097,447.637,146.36,447.193,145.734,446.572z"
                            />
                          </g>
                        </svg>
                      </a>
                      &nbsp;
                      <button
                        class="button button-error"
                        v-on:click="deleteRevista(index)"
                      >
                        <svg
                          style="
                            margin-top: 4px;
                            width: 12px;
                            height: 12px;
                            fill: #fff;
                          "
                          x="0px"
                          y="0px"
                          viewBox="0 0 459 459"
                        >
                          <g>
                            <path
                              d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"
                            />
                          </g>
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Edit from "./Edit";
import { get, post, put, del, uploadImage } from "@/helpers/apiRequest";
import { getImage } from "@/helpers/utils";
const url = "/revistas";

const REVISTA_MODEL = {
  descricao: "",
  ordem: 0,
  dataPubli: Date.now(),
  img: "",
  visivel: false,
  numero: 1,
  link: "/revistas/revista_1",
  pdf: "",
  file: "",
};

export default {
  components: {
    Edit,
  },
  name: "revistas",
  data() {
    return {
      loading: false,
      error: null,
      editorFunction: () => {},
      editorMode: "create",
      revistas: [],
      currentRevista: { ...REVISTA_MODEL },
      numerosCadastrados: [],
    };
  },
  methods: {
    getImage: getImage,

    openEditor(index = -1) {
      if (index < 0) {
        this.currentRevista = { ...REVISTA_MODEL };
        this.editorFunction = this.createRevista;
        this.editorMode = "create";
      } else {
        this.currentRevista = { ...this.revistas[index] };
        this.editorFunction = this.updateRevista;
        this.editorMode = "update";
      }

      this.$modal.show("editRevista");
    },
    closeEditor() {
      this.currentRevista = { ...REVISTA_MODEL };
      this.$modal.hide("editRevista");
    },

    onEditSuccess() {
      this.$modal.hide("editRevista");
      this.fetchRevistas();
    },

    edit(apiMethod, onSuccess, onError, onFinish) {
      this.loading = true;
      return apiMethod()
        .then((json) => {
          this.error = null;
          if (onSuccess && typeof onSuccess === "function") {
            onSuccess();
          }
        })
        .catch((err) => {
          this.error = err;
          if (onError && typeof onError === "function") {
            onError();
          }
        })
        .finally(() => {
          this.loading = false;
          if (onFinish && typeof onFinish === "function") {
            onFinish();
          }
        });
    },

    updateRevista(callback) {
      const formData = revistaFormData(this.currentRevista);
      const apiMethod = put.bind(
        this,
        `${url}/${this.currentRevista._id}`,
        formData,
        { isFile: true }
      );

      this.edit(apiMethod, this.onEditSuccess);
    },

    createRevista(callback) {
      const formData = revistaFormData(this.currentRevista);
      const apiMethod = post.bind(this, url, formData, { isFile: true });
      this.edit(apiMethod, this.onEditSuccess);
    },

    deleteRevista(index, callback) {
      this.$swal({
        title: "Confirma remover?",
        showCancelButton: true,
        type: "error",
        confirmButtonColor: "#d82727",
      }).then(() => {
        const { _id } = this.revistas[index];
        const apiMethod = del.bind(this, `${url}/${_id}`);
        this.edit(apiMethod, this.onEditSuccess);
      });
    },

    fetchRevistas(callback) {
      this.loading = true;
      get(url)
        .then((json) => {
          this.revistas = json;
          this.numerosCadastrados = this.revistas.map(
            (revista) => revista.numero
          );
          this.error = null;
        })
        .catch((err) => {
          this.error = err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    uploadImage(index) {
      event.preventDefault();
      const { _id } = this.revistas[index];
      const settings = {
        el: event.target,
        str: `/revistas/img/${_id}?single=true`,
        dim: "255x255",
      };
      this.loading = true;
      const apiMethod = uploadImage.bind(this, settings);
      this.edit(apiMethod, this.onEditSuccess);
    },

    deleteImg(index) {
      this.$swal({
        title: "Confirma remover?",
        showCancelButton: true,
        type: "error",
        confirmButtonColor: "#d82727",
      }).then(() => {
        const { _id } = this.revistas[index];
        const apiMethod = del.bind(
          this,
          `/upload/revistas/img/${_id}/no-index/?single=true`
        );
        this.edit(apiMethod, this.onEditSuccess);
      });
    },
  },

  beforeMount() {
    this.fetchRevistas();
  },
};

function revistaFormData(data) {
  const formData = new FormData();
  for (const [key, val] of Object.entries(data)) {
    formData.append(key, val);
  }
  return formData;
}
</script>



// WEBPACK FOOTER //
// src/views/Revistas/Revistas.vue